<script>
export default {
  name: 'productAuthorization',
  data() {
    return {
      username: localStorage.getItem('name'),
      stock: [],
      users: [],
      // 搜索条件
      queryForm: {
        phone: ''
      },
      clients:[],
      client:'',
      // 表格数据
      loading: true,
      tableData: [],
      dialogVisible: false,
      currentPage: 1,
      pageSize: 10,
      choice: [],
      total: 0,
      options: [{value: null, label: '不允许'}, {value: 0, label: '普通客户价'}, {
        value: 1,
        label: '一级批发价'
      }, {value: 2, label: '二级批发价'}, {value: 3, label: '三级批发价'}, {
        value: 4,
        label: '四级批发价'
      }, {value: 5, label: '五级批发价'}, {value: 6, label: '六级批发价'}, {
        value: 7,
        label: '七级批发价'
      }, {value: 8, label: '八级批发价'}, {value: 9, label: '九级批发价'}, {value: 10, label: '十级批发价'}],
      optionProps: {
        expandTrigger: 'hover',
        title: "name",
        label: "name",
        value: "id",
        children: "children",
        checkStrictly: true
      },
      ProductAuthorization: {
        id: '',
        phone: '',
        stockId: "",
        scatteredPrice: "",
        wholePrice: "",
      },
    }
  },
  created() {
    this.$axios.get("/admin/partner").then((res) => {
      var client = res.data.data
      client.unshift({id: 0, idsettlementPartner: 0, name: ' '})
      this.clients = client
    })
  },
  mounted() {
    this.getStock()
    this.getList()
    this.getUsers()
  },
  methods: {
    handleSearch() {
      this.currentPage = 1
      this.getList()
    },
    handleReset() {
      this.queryForm.phone = ''
      this.currentPage = 1
      this.getList()
    },
    getStock() {
      this.$axios.get("/admin/stock/classSortAndClass").then((res) => {
        this.stock = res.data.data
      })
    },
    // 新增：获取用户列表 (用于选择手机号)
    getUsers() {
      // 复用项目中存在的 /admin/user/all 接口
      this.$axios.get('/admin/user/all').then((res) => {
        // 假设返回结构为 { data: [...] }
        this.users = res.data.data || []
      }).catch(() => {
        this.users = []
      })
    },
    // 获取数据
    getList() {
      this.loading = true
      this.$axios.get("/admin/productAuthorization", {
        params: {
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          phone: (this.queryForm.phone || '').toString().trim(),
        }
      }).then((res) => {
        this.tableData = res.data.data.records
        this.total = res.data.data.total
        this.loading = false
      })
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    },
    selectProductType(data) {
      const {value, label} = data;

      this.ProductAuthorization.name = value
      this.ProductAuthorization.code = label
    },

    close() {
      this.dialogVisible = false
      this.clearForm()
    },
    clearForm() {
      this.ProductAuthorization.id = ''
      this.ProductAuthorization.phone = ''
      this.ProductAuthorization.stockId = ''
      this.ProductAuthorization.scatteredPrice = ''
      this.ProductAuthorization.wholePrice = ''
      this.ProductAuthorization.name = ''
      this.ProductAuthorization.code = ''
      this.client = ''
    },
    handleSelectionChange(v) {
      this.choice = v
    },
    batchDelete() {
      let name = ''
      this.choice.forEach(e => {
        name += e.name + '，'
      })
      this.$confirm('此操作将永久删除' + name + '的商品授权, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let id = ''
        this.choice.forEach(e => {
          id += e.id + '_'
        })
        id = id.substring(0, id.length - 1)
        this.$axios.delete("/admin/productAuthorization/batch/" + id).then(() => {
          this.$axios.post("/admin/log", {
            "type": "管理员",
            "module": "商品授权管理",
            "name": this.username,
            "content": "删除了'" + name + "'的商品授权"
          })
          this.getList()
          this.$message.success("删除成功")
        }).catch(() => {
          this.$message.error("修改失败")
        })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },

    deleteProductAuthorization(e) {
      this.$confirm('此操作将永久删除' + e.name + '的商品授权, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.delete("/admin/productAuthorization/" + e.id).then(() => {
          this.$message.success('删除成功!');
          this.$axios.post("/admin/log", {
            "type": "管理员",
            "module": "商品授权管理",
            "name": this.username,
            "content": "删除了" + e.name + "的商品授权"
          })
          this.getList()
        }).catch(() => {
          this.$message.error("修改失败")
        })
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },
    addProductAuthorization() {
      console.log(this.ProductAuthorization)
      if (typeof this.ProductAuthorization.stockId != "string") {
        let id = "";
        this.ProductAuthorization.stockId.forEach((item) => {
          id += item + '_'
        })
        this.ProductAuthorization.stockId = id.substring(0, id.length - 1)
      }
      if (this.ProductAuthorization.phone==null || this.ProductAuthorization.phone.trim() === '') {
        this.$message.error('请输入手机号')
        return
      }
      if (this.ProductAuthorization.stockId==null || this.ProductAuthorization.stockId.trim() === '') {
        this.$message.error('请选择商品')
        return
      }


      this.$axios.post("/admin/productAuthorization",  this.ProductAuthorization).then(() => {
        this.$axios.post("/admin/log", {
          "type": "管理员",
          "module": "商品授权管理",
          "name": this.username,
          "content": "添加" + this.ProductAuthorization.phone + " 的商品授权"
        })
        this.getList()
        this.close()
        this.dialogVisible = false
        this.$message.success('添加成功!');
      }).catch(() => {
        this.$message.error("添加失败")
      })
    }, out() {
      this.$router.push({name: 'login'})
    },
    changeClient(r){
      if (this.users.find(u=>u.client===r) == null||r==0){
        this.ProductAuthorization.phone = ''
        this.$message.error("未找到匹配用户")
        return
      }
      this.ProductAuthorization.phone = this.users.find(u=>u.client===r).phone
      console.log(r)
    },
    changePhone(r){
      this.client = this.users.find(u => u.phone === r).client
      console.log(r)
    }
  }
}
</script>
<template>
  <div>
    <el-header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>商品授权管理</el-breadcrumb-item>
        <div style="position: absolute; right: 100px;top: 20px;font-size: 15px">
          <div style="display:flex;align-items:center;">
            <el-avatar size="large" style="margin: 5px;"
                       src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"></el-avatar>
            {{ username }}
            <el-button type="text" @click="out" style="margin: 5px;">退出登录</el-button>
          </div>
        </div>
      </el-breadcrumb>

      <!-- 搜索区域：按手机号过滤 -->
      <div style="align-items:center;gap:10px;margin-top:15px;flex-wrap:wrap;margin-bottom: 20px">
        <el-button class="topInput" type="primary" @click="dialogVisible = true">添加商品</el-button>
        <el-button class="topInput" type="danger" @click="batchDelete">批量删除</el-button>
        <el-input
            v-model="queryForm.phone"
            clearable
            placeholder="搜索手机号"
            style="width:220px"
            @keyup.enter.native="handleSearch"
        />
        <el-button type="primary" @click="handleSearch">搜索</el-button>
        <el-button @click="handleReset">重置</el-button>
      </div>


      <!--      可拖拽表格调整展示顺序-->
    </el-header>
    <el-main class="el-main">
      <el-table
          v-loading="loading"
          :data="tableData"
          stripe
          border
          @selection-change="handleSelectionChange"
          highlight-current-row
          current-row-key="id"
          row-key="id"
          max-height="500">
        <el-table-column
            type="selection"
            width="55">
        </el-table-column>
        <el-table-column label="序号" width="50" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="用户" prop="phone" width="180" align="center">
          <template slot-scope="scope">
            <div style="display:flex;align-items:center;justify-content:center;">
              <span>{{ scope.row.phone }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="client" label="客户姓名" width="150">
          <template slot-scope="scope">
            {{
              clients.find(c => c.id == (users.find(u => u.phone === scope.row.phone).client))==null?"":clients.find(c => c.id == (users.find(u => u.phone === scope.row.phone).client)).name
            }}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="商品名称" align="center" width="300"></el-table-column>
        <el-table-column prop="scatteredPrice" label="散价" width="91" align="center">
          <template slot-scope="scope">
            {{ options.find(key => key.value === scope.row.scatteredPrice).label }}
          </template>
        </el-table-column>
        <el-table-column prop="wholePrice" label="整件价格" width="91" align="center">
          <template slot-scope="scope">
            {{ options.find(key => key.value === scope.row.wholePrice).label }}
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" align="center" width="150">
          <template slot-scope="scope">
            <el-button @click="deleteProductAuthorization(scope.row)" type="text" size="medium">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-footer class="el-footer" id="page">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          :pager-count="11"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </el-footer>

    <el-dialog title="添加商品" :visible.sync="dialogVisible">
      <el-form :model="ProductAuthorization" :inline="true">
        <el-form-item label="手机号">
          <el-select filterable clearable v-model="ProductAuthorization.phone" placeholder="请选择用户手机号" style="width:220px" @change="changePhone">
            <el-option v-for="u in users" :key="u.phone" :label="u.phone + (u.name ? (' - ' + u.name) : '')" :value="u.phone"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户姓名" label-width="70px">
          <el-select v-model="client" filterable placeholder="请选择" @change="changeClient">
            <el-option
              v-for="item in clients"
              :key="item.id"
              :label="item.name"
              :value="Number(item.id)">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品">
          <el-cascader
              filterable
              size="medium"
              v-model="ProductAuthorization.stockId"
              :options="stock"
              :props=optionProps
              placeholder="请选择" @change="selectProductType"
              clearable></el-cascader>
        </el-form-item>
        <el-form-item label="散价" label-width="70px">
          <el-select v-model="ProductAuthorization.scatteredPrice" placeholder="请选择">
            <el-option

              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="整件价格" label-width="70px">
          <el-select v-model="ProductAuthorization.wholePrice" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close()">取 消</el-button>
        <el-button type="primary" @click="addProductAuthorization()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<style scoped>
.el-header {
  margin-top: 30px;
  margin-left: 25px;
}

.topInput {
  margin-top: 15px;
  margin-bottom: 30px;
}

.el-form .el-form-item {
  margin: 10px;
}

.el-main {
  margin-top: 10px;
  margin-left: 25px;
}

.el-footer {
  text-align: center;
  margin-top: 25px;
}

</style>



// WEBPACK FOOTER //
// src/views/productAuthorization.vue